module.exports = __webpack_public_path__ + "static/media/Logo_flomecol.a61b9a7b.svg";